import felineLeftSideImage from '../../ImageDiagnosis/diagnosisImages/assets/feline-leftside.png';
import felineRightSideImage from '../../ImageDiagnosis/diagnosisImages/assets/feline-rightside.png';
import {
  orthopedicOther,
  orthopedicOa,
  degenerativeDiscDisease,
  trauma,
  muscleInjury,
  hipDysplasia,
  luxation,
  patellarLuxation,
  meniscalInjury
} from '../painConditions';
import { DxImageWithPointsAndConditions } from '../imageDxTypes';

// felineDxImages is the list of image (right and left sides) with all points for the cat pain diagnosis.
export const felineDxImages: DxImageWithPointsAndConditions[] = [
  {
    name: 'Right Side',
    imageUrl: felineRightSideImage,
    points: [
      {
        label: 'Vertebral',
        name: 'vertebral',
        x: 388,
        y: 181,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Right Shoulder',
        name: 'right_shoulder',
        x: 506,
        y: 253,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Right Elbow',
        name: 'right_elbow',
        x: 446,
        y: 329,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          meniscalInjury
        ]
      },
      {
        label: 'Right Carpal',
        name: 'right_carpal',
        x: 470,
        y: 445,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Right Metatarsophalangeal',
        name: 'right_metatarsophalangeal',
        x: 167,
        y: 449,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Right Tarsal',
        name: 'right_tarsal',
        x: 161,
        y: 377,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Right Stifle',
        name: 'right_stifle',
        x: 245,
        y: 303,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          patellarLuxation
        ]
      },
      {
        label: 'Right Hip',
        name: 'right_hip',
        x: 219,
        y: 229,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          hipDysplasia
        ]
      }
    ]
  },
  {
    name: 'Left Side',
    imageUrl: felineLeftSideImage,
    points: [
      {
        label: 'Vertebral',
        name: 'vertebral',
        x: 282,
        y: 181,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Left Shoulder',
        name: 'left_shoulder',
        x: 164,
        y: 253,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Left Elbow',
        name: 'left_elbow',
        x: 224,
        y: 329,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          meniscalInjury
        ]
      },
      {
        label: 'Left Carpal',
        name: 'left_carpal',
        x: 200,
        y: 445,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Left Metatarsophalangeal',
        name: 'left_metatarsophalangeal',
        x: 503,
        y: 449,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Left Tarsal',
        name: 'left_tarsal',
        x: 509,
        y: 377,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, luxation, muscleInjury]
      },
      {
        label: 'Left Stifle',
        name: 'left_stifle',
        x: 425,
        y: 303,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          patellarLuxation
        ]
      },
      {
        label: 'Left Hip',
        name: 'left_hip',
        x: 451,
        y: 229,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          degenerativeDiscDisease,
          trauma,
          luxation,
          muscleInjury,
          hipDysplasia
        ]
      }
    ]
  }
];
